import React, { useState, useEffect, useRef } from 'react';
import { Button, Input, Table, Form,Popover, Spin, Select, Image, Space } from 'antd';
import { SearchOutlined, RedoOutlined, DownloadOutlined } from '@ant-design/icons';
import PopupFrame from '../../component/popupFrame/popupFrame';//删除弹框
import Audit from '../../component/audit/audit';//審核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { ContextHandler } from '../../public/js/contextHandler';
import context from '../../public/js/context';
import moment from 'moment';//日期格式化导包
import trans from './translation';
import Message from '../../component/message/message';
import './academicStudentReport.css'

const { Option } = Select;

const PartnerIndustrialPartnerReport = (props) => {
    const messageRef = useRef();
    const [form] = Form.useForm();
    const [tabIndex, setTabIndex] = useState("1");
    const [flag, setFlag] = useState("add");
    const [isAudit, setIsAudit] = useState(false);
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [auditModel, setAuditModel] = useState({});
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isLeave, setIsLeave] = useState(false);
    const [studentModel, setStudentModel] = useState({});
    const [studentProgList, setStudentProgList] = useState([]);
    const [downloadModel, setDownloadModel] = useState("");

    const tableColumns = {
        companyName:"companyName",
        contactName:"contactName",
        companyLocation:"companyLocation",
        userCode:"userCode",
        contactTitle:"contactTitle",
        contactJobTitle:"contactJobTitle",
        contactDept:"contactDept",
        theiContactName:"theiContactName",
        theiDeptName:"theiDeptName",
        mainContact:"mainContact",
        activeInd:"activeInd",
        inactiveDate:"inactiveDate",
    }
    useEffect(() => {
        search(pageSize, 1, "N");
    }, []);

    useEffect(() => {
        search(pageSize, 1, "N");
    }, [Config.programmeInfo.progCode]);

    const searchChange = (k, e) => {
        messageShowHandler();
        setSearchModel(newSearchModel => {
            return { ...newSearchModel, ...{ [k]: e } };
        })
    }

    //查询
    const search = (pageSizeNew, current, flag, isShowMsg) => {
        messageShowHandler();
        let model = {};
        if ("Y" === flag) {//翻頁
            model = oldSearchModel;
        } else {
            model = searchModel;
        }
        model.pageSize = pageSizeNew;
        model.startRow = (current - 1) * pageSizeNew;
        model.page = current;
        setDownloadModel(model)
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("partnerContact/getExportList", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data.object.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(current);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    //重置
    const reset = () => {
        messageShowHandler();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    // Tab页切换
    const handleSelect = (key) => {
        if (key) {
            if (key === "2") {
                if (Config.funcInfo.canInsert === "Y") {
                    add();
                }
            } else if (tabIndex !== "1") {
                setTabIndex("1");
                search(pageSize, current, "Y");
            }
        }
    }

    //添加
    const add = () => {
        messageShowHandler();//清空提示信息
        setStudentModel({})
        setStudentProgList([])
        initForm({ activeInd: 'Y', dataPrivacyNoticeInd: 'Y' });
        setFlag("add");
        setTabIndex("2");
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            studentAcctId: model.studentAcctId ?? '',
            studentName: model.studentName ?? '',
            email: model.email ?? '',
            birthMonth: (model.birthMonth && moment(model.birthMonth, Config.dateFormat6)) ?? '',
            activeInd: model.activeInd ?? '',
            inactiveDate: (model.inactiveDate && moment(model.inactiveDate)) ?? null,
            dataPrivacyNoticeInd: model.dataPrivacyNoticeInd ?? '',
        });
    }
    
    // 审核弹窗
    const auditCancel = () => {
        setIsAudit(false);
    }

    //取消 
    const cancel = () => {
        messageShowHandler();
        setTabIndex("1");
        search(pageSize, current, "Y");
    }

    const leaveFrameClose = (state) => {
        if (state) {
            cancel();
        }
        setIsLeave(false);
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }

    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    /** 生成提示信息 */
    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    /** 清空提示信息 */
    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }


    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }

    const downloadExcel = () => {
        messageShowHandler();//清空提示信息
        setIsLoad(true);
        setSpinInfo(trans.download[Config.backLang])
        const filename = "Industry Partner Report" + moment(new Date()).format(Config.dateFormat3) + Base.generateFourDigitRandomNumber() + ".xlsx"
        fetch(Config.apiDownloadServer + "partnerContact/exportReport", {
            method: 'POST',
            body: JSON.stringify(downloadModel),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.blob()).then(blob => {
            if (blob.type == "application/json") {
                var reader = new FileReader();
                reader.onload = e => {
                    var data = JSON.parse(e.target.result);
                    errFrameShow("error", data.msg);
                }
                reader.readAsText(blob);
            } else {
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {// for IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {// for Non-IE (chrome, firefox etc.)
                    var a = document.createElement('a');
                    document.body.appendChild(a);
                    a.style = 'display: none';
                    var url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = filename
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                }
            }
        }).catch(err => ({ err })).finally(() => {
            setIsLoad(false)
        });
    }


    /*eslint-disable*/
    const columns = [
        {
            title: 'Company Logo',
            dataIndex: 'companyLogo',
            className: 'tableWidth4',
            render: (text, record) => <div className=''>
                { text && <Image width={70} height={70} src={text ? Config.partnerImg + text + '?' + Config.sasToken : ""}></Image>}
            </div>
        },
        {
            title: 'Company Name',
            dataIndex: 'companyName',
            className: 'tableWidth5',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'companyName') },
        },
        {
            title: 'Company Location',
            dataIndex: 'companyLocation',
            className: 'tableWidth6',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'companyLocation') },
            render: (text) => <Popover content={text} title="" trigger="hover">
                <div className = "studentDept">{text}</div>
            </Popover>
        },
        {
            title: 'Company Website',
            dataIndex: 'companyWebsite',
            className: 'tableWidth5',
            render: (text) => <Popover content={text} title="" trigger="hover">
                <div className = "studentDept">{text}</div>
            </Popover>
        },
        {
            title: 'Company LinkedIn',
            dataIndex: 'companySocailMedia',
            className: 'tableWidth6',
            render: (text) => <Popover content={text} title="" trigger="hover">
                <div className = "studentDept">{text}</div>
            </Popover>
        },
        {
            title: 'Company YouTube',
            dataIndex: 'companyYouTuBe',
            className: 'tableWidth5',
            render: (text) => <Popover content={text} title="" trigger="hover">
                <div className = "studentDept">{text}</div>
            </Popover>
        },
        {
            title: 'Company Profile',
            dataIndex: 'companyProfile',
            className: 'tableWidth5',
            render: (text) => <Popover content={text} title="" trigger="hover">
                <div className = "studentDept">{text}</div>
            </Popover>
        },
        
        {
            title: 'Contact ID',
            dataIndex: 'userCode',
            className: 'tableWidth4',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'userCode') },
        },
        {
            title: 'Contact Title',
            dataIndex: 'contactTitle',
            className: 'tableWidth5',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'contactTitle') },
        },
        {
            title: 'Contact Name',
            dataIndex: 'contactName',
            className: 'tableWidth5',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'contactName') },
        },
        {
            title: 'Contact Job Title',
            dataIndex: 'contactJobTitle',
            className: 'tableWidth5',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'contactJobTitle') },
        },
        {
            title: 'Contact Department',
            dataIndex: 'contactDept',
            className: 'tableWidth7',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'contactDept') },
        },
        {
            title: 'Contact Email',
            dataIndex: 'contactEmail',
            className: 'tableWidth4',
        },
        {
            title: 'Contact Office Phone',
            dataIndex: 'contactOfficePhone',
            className: 'tableWidth5',
        },
        {
            title: 'Contact Mobile Phone',
            dataIndex: 'contactMobilePhone',
            className: 'tableWidth5',
        },
        {
            title: 'THEi Requestor Name',
            dataIndex: 'theiContactName',
            className: 'tableWidth6',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'theiContactName') },
        },
        {
            title: 'THEi Requestor Department',
            dataIndex: 'theiDeptName',
            className: 'tableWidth7',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'theiDeptName') },
            render: (text) => <Popover content={text} title="" trigger="hover">
                <div className = "studentDept">{text}</div>
            </Popover>
        },
        {
            title: 'Main Contact',
            dataIndex: 'mainContact',
            className: 'tableWidth4',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'mainContact') },
            render: (text) => ContextHandler.getMapValue('indStatusMap', text)
        },
        {
            title: 'Status',
            dataIndex: 'activeInd',
            className: 'tableWidth3',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'activeInd') },
            render: (text) => ContextHandler.getMapValue('activeMap', text)
        },
        {
            title: 'Inactive Date',
            dataIndex: 'inactiveDate',
            className: 'tableWidth8',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'inactiveDate') },
            render: (text) => text!=null?moment(text).format(Config.dateFormat5):null
        },
    ];

    const submit = () => {
        search(pageSize, 1, "N", true);
    }
    const checkStartDate = (rule, value) => {
        if (Base.isNotEmpty(searchModel.endDate) && Base.afterDate(value, searchModel.endDate)) {
            return Promise.reject("To Date cannot be earlier than From Date.")
        }
        return Promise.resolve();
    }
    const checkEndDate = (rule, value) => {
        if (Base.isNotEmpty(searchModel.startDate) && Base.afterDate(searchModel.startDate, value)) {
            return Promise.reject("From Date cannot be later than To Date.")
        }
        return Promise.resolve();
    }

    /*eslint-enable*/

    return (
        <div id="container" className="websiteTemplate academicStudentReport">
            <div className='title'>
                <div>Industry Partner Report</div>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin spinning={isLoad} size="large" tip={spinInfo}>
                    {/* 删除弹框 */}
                    {isLeave ? <PopupFrame close={leaveFrameClose} type='leave' /> : null}
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                    <Form form={form} onFinish={submit}>
                        <div className='sysSearchRow sysSearchBox'>
                            <div className='sysRow'>
                                <div className='sysCol'>
                                    <div className="sysTitle messageTemplateTitle">Company Name</div>
                                    <div className="sysSerchInput ">
                                        <Input type="text" value={searchModel.companyName || ''} maxLength={60}
                                            placeholder="Company Name"
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                            onChange={(e) => searchChange('companyName', e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className='sysCol'>
                                    <div className="sysTitle messageTemplateTitle">Company Location</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" value={searchModel.companyLocation || ''} maxLength={200}
                                            placeholder="Company Location"
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                            onChange={(e) => searchChange('companyLocation', e.target.value)}
                                        />
                                    </div>
                                </div>
                                
                                <div className='sysCol'>
                                    <div className="sysTitle messageTemplateTitle">Contact ID</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" value={searchModel.partnerContactAcctId || ''} maxLength={100}
                                            placeholder="Contact ID"
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                            onChange={(e) => searchChange('partnerContactAcctId', e.target.value)} />
                                    </div>
                                </div>

                                <div className='sysCol'>
                                    <div className="sysTitle messageTemplateTitle">Contact Name</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" value={searchModel.contactName || ''} maxLength={100}
                                            placeholder="Contact Name"
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                            onChange={(e) => searchChange('contactName', e.target.value)} />
                                    </div>
                                </div>

                                <div className='sysCol'>
                                    <div className="sysTitle messageTemplateTitle">THEi Requestor Name</div>
                                    <div className="sysSerchInput">
                                        <Input type="text" value={searchModel.theiContactName || ''} maxLength={40}
                                            placeholder="THEi Requestor Name"
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                            onChange={(e) => searchChange('theiContactName', e.target.value)} />
                                    </div>
                                </div>

                                <div className='sysCol'>
                                    <div className="sysTitle messageTemplateTitle">{trans.activeInd[Config.backLang]}</div>
                                    <div className="sysSerchInput">
                                        <Select className="sysSelect" placeholder={trans.activeInd[Config.backLang]}
                                            value={searchModel.activeInd}
                                            onChange={(e) => searchChange('activeInd', e)}
                                        >
                                            <Option value=""></Option>
                                            {context.activeTransalation.map((item) => <Option key={item.value} value={item.value}>{item[Config.backLang]}</Option>)}
                                        </Select>
                                    </div>
                                </div>
                                <div className='sysSearchButton'>
                                    <Button className="sysBtn btnBlue" type="primary" htmlType="submit"  icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                    <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                                </div>
                            </div>
                        </div>
                    </Form>
                    <div className="sysLineEight"></div>
                    <Space size={[5, 5]} wrap className="sysButtonRelative">
                    {tables.length == 0 ? null :
                        <>
                        <Button className="sysBtn btnBlue" type="primary" onClick={downloadExcel}  icon={<DownloadOutlined />}>Export</Button>
                        </>
                    }
                    </Space>
                    <div className="sysTable" id="tableOne">
                        <Table
                            scroll={{ x: 4100 }}
                            rowKey="index"
                            columns={columns} //列名
                            dataSource={tables} //数据
                            pagination={{  //分页
                                showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                                onChange: onChange,            //上页下页或者跳页方法
                                onShowSizeChange: onShowSizeChange,    //每页显示多少条数据方法
                                total: tablesCount,             //总共多少条数据
                                current: current,         //当前页
                                pageSize: pageSize,       //每页显示多少条数据
                                defaultCurrent: 1,                               //默认当前页为1
                                size: "small"
                            }}
                            onChange={handleTableChange}
                        />
                    </div>

                </Spin>
            </div>

        </div>
    )
}

export default PartnerIndustrialPartnerReport;